import { ExtendedFieldsActionTypes } from "us.collection.admin/constants/Actions/ExtendedFields";
import { IAPIAction } from "us.collection/interfaces";

const {
  GET_EXTENDED_FIELDS,
  GET_EXTENDED_FIELDS_SUCCESS,
  GET_EXTENDED_FIELDS_FAILURE,

  GET_EXTENDED_FIELD_SP_LIST,
  GET_EXTENDED_FIELD_SP_LIST_SUCCESS,
  GET_EXTENDED_FIELD_SP_LIST_FAILURE,

  NEW_EXTENDED_FIELD,
  NEW_EXTENDED_FIELD_SUCCESS,
  NEW_EXTENDED_FIELD_FAILURE,
  MANAGE_DRAWER,

  UPDATE_EXTENDED_FIELD,
  UPDATE_EXTENDED_FIELD_SUCCESS,
  UPDATE_EXTENDED_FIELD_FAILURE,

  DELETE_EXTENDED_FIELD,
  DELETE_EXTENDED_FIELD_SUCCESS,
  DELETE_EXTENDED_FIELD_FAILURE,

  GET_DATA_TYPES,
  GET_DATA_TYPES_SUCCESS,
  GET_DATA_TYPES_FAILURE,
} = ExtendedFieldsActionTypes;

export const extendedFields: Readonly<IAPIAction> = {
  fields: {
    get: (data) => ({
      type: GET_EXTENDED_FIELDS,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_EXTENDED_FIELDS_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_EXTENDED_FIELDS_FAILURE,
      payload: {
        error,
        isLoading: false,
      },
    }),
    openDrawer: (data) => ({
      type: MANAGE_DRAWER,
      payload: {
        data,
        isLoading: true,
      },
    }),
  },
  storedProcedures: {
    get: (data) => ({
      type: GET_EXTENDED_FIELD_SP_LIST,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_EXTENDED_FIELD_SP_LIST_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_EXTENDED_FIELD_SP_LIST_FAILURE,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  dataTypes: {
    get: (data) => ({
      type: GET_DATA_TYPES,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_DATA_TYPES_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_DATA_TYPES_FAILURE,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  newExtendedField: {
    save: (data) => ({
      type: NEW_EXTENDED_FIELD,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: NEW_EXTENDED_FIELD_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: NEW_EXTENDED_FIELD_FAILURE,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  extendedFieldDetails: {
    save: (data) => ({
      type: UPDATE_EXTENDED_FIELD,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: UPDATE_EXTENDED_FIELD_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: UPDATE_EXTENDED_FIELD_FAILURE,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  deleteExtendedField: {
    save: (data) => ({
      type: DELETE_EXTENDED_FIELD,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: DELETE_EXTENDED_FIELD_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: DELETE_EXTENDED_FIELD_FAILURE,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
};
